import { Box, Container, Divider, Grid, Typography } from "@mui/material";
import axios from "axios";
import {
  ArrayChip,
  AutoCompleteComponent,
  CurrencyNumberInput,
  CustomTable,
  FormLabel,
  ModalError,
  ModalSuccess,
  ModalWarning,
  MultipleSelectInput,
  Page,
  PrimaryButton,
  SectionLabel,
  SkeletonComponent,
  TextInput,
} from "components";
import { API_ENDPOINTS } from "constants";
import { HeaderTitle } from "layouts";
import { generateUniqueId, getTotalPage } from "lib";
import { useEffect, useMemo, useState } from "react";
import { useHistory, useParams } from "react-router";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import {
  arrayToCommaSeparatedString,
  getErrors,
  paginateDataTable,
} from "utils";
import {
  ModalAddSongAlias,
  ModalAssetId,
  ModalComposerConfiguration,
  ModalPerformer,
} from "./Components";

const FormParameterSong = () => {
  const classes = globalStyles();
  const history = useHistory();
  const { id } = useParams();
  const pageTitle = id ? "Edit Song" : "Add Song";
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const publisherId = parseInt(localStorage.getItem("publisher"), 10) || 0;
  const [loadingPage, setLoadingPage] = useState(false);
  const [optionOriginalPublisher, setOptionOriginalPublisher] = useState([]);
  const [optionRole, setOptionRole] = useState([]);
  const [modalSongAlias, setModalSongAlias] = useState(false);
  const [modalPerformer, setModalPerformer] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [modalComposer, setModalComposer] = useState(false);
  const [modalAsset, setModalAsset] = useState(false);
  const [dataTableAlias, setDataTableAlias] = useState([]);
  const [selectedAlias, setSelectedAlias] = useState(null);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [selectedPerformer, setSelectedPerformer] = useState(null);
  const [payload, setPayload] = useState({
    song_id: 0,
    song_title: "",
    iswc_code: "",
    original_publisher_id: 0,
    work_code: "",
    song_aliases: [],
    song_composers: [],
    song_recordings: [],
    assets_ids: [],
    publisher_share_percentage: 0,
  });
  const [tableAlias, setTableAlias] = useState({
    page: 1,
    size: 5,
  });
  const [tableAssets_ids, setTableAssets_ids] = useState({
    page: 1,
    size: 5,
  });
  const [queryParams, setQueryParams] = useState({
    page: 1,
    size: 5,
  });
  const tableTotalPage =
    getTotalPage(payload?.song_recordings?.length, queryParams?.size) || 1;
  const tableTotalPageAssets =
    getTotalPage(payload?.assets_ids?.length, tableAssets_ids?.size) || 1;
  const tableTotalPageAlias =
    getTotalPage(dataTableAlias?.length, tableAlias?.size) || 1;

  const handleChangeQueryTableAlias = (value, key) => {
    setTableAlias(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };
  const handleChangeQueryTableAssets = (value, key) => {
    setTableAssets_ids(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };
  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };
  const handleChangePayload = (value, key) => {
    setPayload(prev => ({ ...prev, [key]: value }));
  };
  const handleAddAlias = value => {
    setDataTableAlias(prev => {
      if (selectedAlias) {
        return prev.map(alias =>
          alias.id === selectedAlias?.id ? { ...alias, name: value } : alias
        );
      } else {
        const newId = prev.length > 0 ? prev[prev.length - 1].id + 1 : 1;
        return [...prev, { id: newId, name: value }];
      }
    });
  };
  const handleAddPerformer = value => {
    const { performers: newPerformers, isrc_code } = value;

    if (isEdit) {
      const updatedPayload = (payload?.song_recordings || []).map(record => {
        if (selectedPerformer?.index === record?.index) {
          const updatedPerformers = newPerformers.map(newPerformer => {
            const existing = record.performers.find(
              p => p.performer_id === newPerformer.performer_id
            );
            return {
              ...existing,
              ...newPerformer,
            };
          });

          return {
            ...record,
            isrc_code,
            performers: updatedPerformers,
          };
        }
        return record;
      });
      setPayload({ ...payload, song_recordings: updatedPayload });
      setIsEdit(false);
    } else {
      const existingIds = (payload?.song_recordings || []).map(
        record => record.song_recording_id
      );
      const newRecording = {
        ...value,
        song_recording_id: generateUniqueId(existingIds),
        isrc_code,
        performers: newPerformers,
      };

      setPayload({
        ...payload,
        song_recordings: [...(payload?.song_recordings || []), newRecording],
      });
    }
  };
  const handleAddComposer = value => {
    setPayload(prev => ({
      ...prev,
      song_composers: value,
    }));
  };
  const handleChangeComposerTable = (value, key, item, option) => {
    setPayload(prev => ({
      ...prev,
      song_composers: prev.song_composers.map(composer => {
        if (
          composer.composer_id !== item?.composer_id ||
          composer.publisher_id !== item?.publisher_id
        ) {
          return composer;
        }
        let updatedComposer = { ...composer };

        if (key === "composer_roles") {
          const checkRole = value.target.checked;
          updatedComposer.composer_roles = checkRole
            ? [...new Set([...composer.composer_roles, option])]
            : composer.composer_roles.filter(role => role.id !== option.id);
        } else {
          updatedComposer[key] = value;
        }

        return updatedComposer;
      }),
    }));
  };

  const getOptionOriginalPublisher = async () => {
    try {
      const res = await axios.get(
        API_ENDPOINTS.GET_PUBLISHER_SONG_ORIGINAL_PUBLISHER,
        { headers }
      );
      const modifiedData = res?.data?.data?.map(item => ({
        ...item,
        id: item?.original_publisher_id,
        label: item?.name,
      }));

      setOptionOriginalPublisher(modifiedData);
    } catch (error) {
      new Error(error);
      ModalError(getErrors(error?.response));
    }
  };
  const getOptionRole = async () => {
    try {
      const res = await axios.get(API_ENDPOINTS.GET_WRITER_ROLE, { headers });
      const modifiedData = res?.data?.data?.map(item => ({
        id: item?.writer_role_code,
        label: item?.writer_role_name,
      }));
      setOptionRole(modifiedData);
    } catch (error) {
      new Error(error);
      ModalError(getErrors(error?.response));
    }
  };
  const getDetail = async () => {
    try {
      const res = await axios.get(`${hardBaseUrl}/songs/${id}`, { headers });
      const { data } = res?.data;
      setPayload(payload => ({
        ...payload,
        ...data,
        song_composers: (data?.song_composers || [])?.map(composer => ({
          ...composer,
          composer_roles: composer?.composer_roles?.map(role => ({ id: role })),
        })),
        assets_ids: data?.dsp_assets || [],
        song_recordings: (data?.song_recordings || [])?.map((song, index) => ({
          index: index,
          ...song,
          performers: song?.performers?.map(performer => ({
            ...performer,
            first_name: performer?.performer_name,
          })),
        })),
      }));
      setDataTableAlias(
        (data?.song_aliases || [])?.map((alias, index) => ({
          id: index + 1,
          name: alias,
        }))
      );
    } catch (error) {
      new Error(error);
      ModalError(getErrors(error?.response));
    }
  };
  const fetcData = async () => {
    setLoadingPage(true);
    const promises = [getOptionOriginalPublisher(), getOptionRole()];
    if (id) promises.push(getDetail());
    try {
      await Promise.all(promises);
    } catch (error) {
      new Error(error);
      ModalError(error, "Error fetching data");
    } finally {
      setLoadingPage(false);
    }
  };
  const handleSubmit = async () => {
    const hasFullPercentage = payload?.publisher_share_percentage > 100;
    if (hasFullPercentage) {
      const res = await ModalWarning(
        "The total ownership share of this song is more than 100%. Do you want to proceed?"
      );
      if (!res.isConfirmed) {
        return;
      }
    }

    const method = id ? axios.put : axios.post;
    const {
      song_composers,
      song_recordings,
      assets_ids,
      ...restPayload
    } = payload;

    const modifiedPayload = {
      ...restPayload,
      dsp_assets: (assets_ids || []).map(
        ({ dsp_id, asset_code, asset_id }) => ({
          dsp_id,
          asset_code,
          asset_id,
        })
      ),
      song_aliases: dataTableAlias?.map(alias => alias?.name),
      song_composers: song_composers?.map(song => ({
        composer_id: song?.composer_id,
        composer_percentage: Number(song?.composer_percentage),
        composer_roles: song?.composer_roles?.map(role => role?.id),
        share_percentage: song?.share_percentage,
        publisher_id: song?.publisher_id || publisherId,
      })),
      song_recordings: song_recordings?.map(record => ({
        isrc_code: record?.isrc_code,
        performers: record?.performers?.map(performer => ({
          performer_id: performer?.performer_id,
          performer_name: performer?.performer_name || performer?.first_name,
          publisher_id: performer?.publisher_id || publisherId,
        })),
      })),
    };

    try {
      setLoadingPage(true);
      await method(
        `${hardBaseUrl}/songs${id ? `/${id}` : ""}`,
        modifiedPayload,
        { headers }
      );
      ModalSuccess(`Successfully ${id ? "save" : "add"} song`).then(() =>
        history.goBack()
      );
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };

  const handleSubmitAsset = item => {
    const { asset_code, dsp_id, asset_id, new_asset_id, dsp_name } = item;
    const new_assets_ids = [...payload?.assets_ids];
    const isEditing = (new_assets_ids || [])?.some(item =>
      item?.new_asset_id
        ? item?.new_asset_id === new_asset_id
        : item?.asset_id === asset_id
    );
    if (isEditing) {
      const filter = (new_assets_ids || [])?.filter(item =>
        item?.new_asset_id
          ? item?.new_asset_id !== new_asset_id
          : item?.asset_id !== asset_id
      );
      const findItem = (new_assets_ids || [])?.find(item =>
        item?.new_asset_id
          ? item?.new_asset_id === new_asset_id
          : item?.asset_id === asset_id
      );
      const newValue = {
        ...findItem,
        asset_code,
        dsp_id,
        dsp_name,
      };
      setPayload(state => ({
        ...state,
        assets_ids: [newValue, ...filter],
      }));
    } else {
      setPayload(state => ({
        ...state,
        assets_ids: [
          {
            dsp_id,
            dsp_name,
            ...(!asset_id
              ? {
                  new_asset_id: generateUniqueId(
                    (new_assets_ids || []).map(record => record.asset_id)
                  ),
                }
              : {}),
            asset_code,
          },
          ...state.assets_ids,
        ],
      }));
    }
    setModalAsset(false);
    setSelectedAsset(null);
  };

  useEffect(() => {
    fetcData();
  }, []);

  useEffect(() => {
    if (payload?.song_composers?.length > 0) {
      const sum = payload?.song_composers.reduce(
        (a, b) => Number(a) + Number(b.composer_percentage),
        0
      );
      handleChangePayload(Number(sum.toFixed(2)), "publisher_share_percentage");
    }
  }, [payload?.song_composers]);
  useEffect(() => {
    if (queryParams.page > tableTotalPage) {
      setQueryParams(currentState => ({
        ...currentState,
        page: currentState?.page - 1,
      }));
    }
  }, [payload?.song_recordings, tableTotalPage]);

  const sortedDataAssets = useMemo(
    () => payload?.assets_ids?.sort((a, b) => a?.asset_code - b?.asset_code),
    [payload?.assets_ids]
  );
  return (
    <Page className={classes.root} title={`${id ? "Edit" : "Add"} Song`}>
      {loadingPage ? (
        <SkeletonComponent variant="wave" />
      ) : (
        <Container maxWidth={false}>
          <HeaderTitle
            title={pageTitle}
            breadcrumbData={breadcrumbData({ pageTitle })}
            backButton
          />
          <Divider className={classes?.divider} />
          <SectionLabel
            title="Song Information"
            subTitle="This feature is used to add a new song."
            my="16px"
          />
          <Box border="1px solid #ebebeb" borderRadius="5px" p="24px" my="16px">
            <Grid container columnSpacing={2} rowSpacing={1}>
              <Grid item xs={12} md={6}>
                <FormLabel label="Song Title" required />
                <TextInput
                  placeholder="Song Title"
                  value={payload?.song_title}
                  onChange={e =>
                    handleChangePayload(e?.target?.value, "song_title")
                  }
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormLabel label="ISWC Code" />
                <TextInput
                  placeholder="ISWC Code"
                  value={payload?.iswc_code}
                  onChange={e =>
                    handleChangePayload(e?.target?.value, "iswc_code")
                  }
                  helperText="eg. US/Z03/21/9102"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormLabel label="Original Publisher" />
                <AutoCompleteComponent
                  placeholder="Original Publisher"
                  options={optionOriginalPublisher}
                  value={
                    optionOriginalPublisher.find(
                      option =>
                        option?.id === Number(payload?.original_publisher_id)
                    ) || null
                  }
                  onChange={value =>
                    handleChangePayload(Number(value), "original_publisher_id")
                  }
                  width="100%"
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormLabel label="Work Code" required />
                <TextInput
                  placeholder="Work Code"
                  value={payload?.work_code}
                  onChange={e =>
                    handleChangePayload(e?.target?.value, "work_code")
                  }
                />
              </Grid>
            </Grid>
          </Box>
          <Divider className={classes?.divider} />
          <Grid container justifyContent="space-between" my="16px">
            <Grid item>
              <SectionLabel title="Song Alias" />
            </Grid>
            <Grid item>
              <PrimaryButton
                label="Add Song Alias"
                onClick={() => setModalSongAlias(true)}
                size="large"
              />
            </Grid>
          </Grid>
          <CustomTable
            columnTable={columnTableAlias}
            data={paginateDataTable({
              data: dataTableAlias || [],
              page: tableAlias?.page,
              size: tableAlias?.size,
            })}
            isHaveAction
            handleEdit={item => {
              setModalSongAlias(true);
              setSelectedAlias(item);
            }}
            handleDelete={item => {
              setDataTableAlias(prev =>
                prev.filter(alias => alias.id !== item?.id)
              );
            }}
            page={tableAlias?.page}
            pageSize={tableAlias?.size}
            pageCount={tableTotalPageAlias}
            handleChangePage={(_, page) =>
              handleChangeQueryTableAlias(page, "page")
            }
            handleChangePageSize={e =>
              handleChangeQueryTableAlias(e?.target?.value, "size")
            }
          />
          <Divider className={classes?.divider} />
          <Grid container justifyContent="space-between" my="16px">
            <Grid item>
              <SectionLabel
                title="Asset ID"
                subTitle="Asset ID of Song's Information"
              />
            </Grid>
            <Grid item>
              <PrimaryButton
                label="Add Asset ID"
                onClick={() => setModalAsset(true)}
                size="large"
              />
            </Grid>
          </Grid>
          <CustomTable
            columnTable={columnTableAssetId}
            data={paginateDataTable({
              data: sortedDataAssets || [],
              page: tableAssets_ids?.page,
              size: tableAssets_ids?.size,
            })}
            isHaveAction
            handleEdit={item => {
              setModalAsset(true);
              setSelectedAsset(item);
            }}
            handleDelete={item => {
              setPayload(prev => ({
                ...prev,
                assets_ids: (prev?.assets_ids || [])?.filter(
                  asset =>
                    asset?.asset_id !== item?.asset_id ||
                    asset?.new_asset_id !== item?.new_asset_id
                ),
              }));
            }}
            page={tableAssets_ids?.page}
            pageSize={tableAssets_ids?.size}
            pageCount={tableTotalPageAssets}
            handleChangePage={(_, page) =>
              handleChangeQueryTableAssets(page, "page")
            }
            handleChangePageSize={e =>
              handleChangeQueryTableAssets(e?.target?.value, "size")
            }
          />
          <Divider className={classes?.divider} />
          <Grid container justifyContent="space-between" my="16px">
            <Grid item>
              <SectionLabel
                title="Performer"
                subTitle="Add Performer list for song's information"
              />
            </Grid>
            <Grid item>
              <PrimaryButton
                label="Add Performer"
                onClick={() => setModalPerformer(true)}
                size="large"
              />
            </Grid>
          </Grid>
          <CustomTable
            columnTable={columnTablePerformer({ classes })}
            data={paginateDataTable({
              data: payload?.song_recordings,
              page: queryParams?.page,
              size: queryParams?.size,
            })}
            page={queryParams?.page}
            pageSize={queryParams?.size}
            pageCount={tableTotalPage}
            handleChangePage={(_, page) =>
              handleChangeQueryParams(page, "page")
            }
            handleChangePageSize={e =>
              handleChangeQueryParams(e?.target?.value, "size")
            }
            isHaveAction
            handleEdit={item => {
              setModalPerformer(true);
              setSelectedPerformer(item);
              setIsEdit(true);
            }}
            handleDelete={item => {
              setPayload(prev => ({
                ...prev,
                song_recordings: prev.song_recordings.filter(
                  recording => recording?.index !== item?.index
                ),
              }));
            }}
          />
          <Divider className={classes?.divider} />
          <Grid container justifyContent="space-between" my="16px">
            <Grid item>
              <SectionLabel
                title="Composer/ Author"
                subTitle="This is the composer/author of the song"
              />
            </Grid>
            <Grid item>
              <Grid container columnSpacing={1} alignItems="center">
                <Grid item>
                  <Typography textAlign="right" fontSize={24}>
                    Percentage :
                    <Typography
                      component="span"
                      fontSize={24}
                      color={payload?.publisher_share_percentage > 100 && "red"}
                    >
                      {`${payload?.publisher_share_percentage} %`}
                    </Typography>
                  </Typography>
                </Grid>
                <Grid item>
                  <PrimaryButton
                    label="Composer/Author Configuration"
                    onClick={() => setModalComposer(true)}
                    size="large"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <CustomTable
            columnTable={columnTableComposer({
              optionRole,
              handleChangeComposerTable,
            })}
            data={payload?.song_composers}
          />
          <Divider className={classes?.divider} />
          <Grid container justifyContent="right" my="16px">
            <PrimaryButton label={id ? "Save" : "Add"} onClick={handleSubmit} />
          </Grid>
        </Container>
      )}
      <ModalAddSongAlias
        open={modalSongAlias}
        onClose={() => {
          setModalSongAlias(false);
          setSelectedAlias(null);
        }}
        preload={selectedAlias?.name}
        handleSubmit={handleAddAlias}
      />
      {modalPerformer && (
        <ModalPerformer
          open={modalPerformer}
          onClose={() => {
            setModalPerformer(false);
            setSelectedPerformer(null);
          }}
          preload={selectedPerformer}
          handleSubmit={handleAddPerformer}
          selectedOptions={payload?.song_recordings}
        />
      )}
      {modalComposer && (
        <ModalComposerConfiguration
          open={modalComposer}
          onClose={() => setModalComposer(false)}
          preload={payload?.song_composers}
          handleSubmit={handleAddComposer}
        />
      )}
      {modalAsset && (
        <ModalAssetId
          open={modalAsset}
          onClose={() => {
            setModalAsset(false);
            setSelectedAsset(null);
          }}
          preload={selectedAsset}
          handleSubmit={item => handleSubmitAsset(item)}
        />
      )}
    </Page>
  );
};

const breadcrumbData = ({ pageTitle }) => [
  {
    label: "Parameter",
    link: "/admin/parameter/lagu",
  },
  {
    label: "Song",
    link: "/admin/parameter/lagu",
  },
  {
    label: pageTitle,
    active: true,
  },
];
const columnTableAlias = [
  {
    name: "name",
    title: "Song Alias",
  },
];
const columnTableAssetId = [
  {
    name: "asset_code",
    title: "Asset ID",
  },
  {
    name: "dsp_name",
    title: "DSP",
  },
];
const columnTablePerformer = ({ classes }) => [
  {
    name: "isrc_code",
    title: "ISRC Code",
    renderText: item => item || "-",
  },
  {
    name: "performers",
    title: "Performer",
    renderText: item => {
      const listValue = item?.map(({ first_name, is_on_this_publisher }) => ({
        name: first_name,
        className: is_on_this_publisher ? classes?.highlightText : "",
      }));
      return <ArrayChip list={listValue} />;
    },
  },
  {
    name: "source",
    title: "ISRC Source",
    renderText: item => item || "-",
  },
];
const columnTableComposer = ({ optionRole, handleChangeComposerTable }) => [
  {
    name: "sure_name",
    title: "Composer/Author Name",
    renderText: item => item || "-",
  },
  {
    name: "alias_names",
    title: "Alias Name",
    renderText: item =>
      <ArrayChip xs={12} list={item.map(performer => performer)} /> || "-",
  },
  {
    name: "all",
    title: "Ownership Percentage",
    renderText: item => (
      <CurrencyNumberInput
        value={item?.composer_percentage}
        onValueChange={values => {
          handleChangeComposerTable(values?.value, "composer_percentage", item);
        }}
        endAdornment="%"
        decimalScale={3}
        disabled={!item?.is_editable || false}
      />
    ),
  },
  {
    name: "all",
    title: "Role",
    renderText: item => (
      <MultipleSelectInput
        placeholder="Composer Role"
        value={item?.composer_roles || []}
        textValue={arrayToCommaSeparatedString(item?.composer_roles, "id")}
        options={optionRole}
        optionKey="id"
        optionLabel="label"
        onChange={(event, option) =>
          handleChangeComposerTable(event, "composer_roles", item, option)
        }
        disabled={!item?.is_editable || false}
        width="100%"
      />
    ),
  },
  {
    name: "all",
    title: "Publisher Percentage",
    renderText: item => (
      <CurrencyNumberInput
        value={item?.share_percentage}
        onChange={value =>
          handleChangeComposerTable(value || 0, "share_percentage", item)
        }
        endAdornment="%"
        disabled={!item?.is_editable || false}
      />
    ),
  },
];
export default FormParameterSong;
